// extracted by mini-css-extract-plugin
export default {"cls1":"tR4mZA2S7cjdd0vM8UST","cls2":"jj0ZzBN1CNpX4fL8kSqp tR4mZA2S7cjdd0vM8UST","isTabletDown":"nMz2ztdQ6ZFunTXdioS9"};